import React, { useState } from 'react';
import Modal from '@App/common/components/Modal/Modal';
import Button from '@Theme/natucare/components/Button/Button';
import FormControl from '@Theme/natucare/components/FormControl/FormControl';
import Input from '@Theme/natucare/components/Input/Input';
import Select from '@Theme/natucare/components/Select/Select';
import Radio from '@Theme/natucare/components/Radio/Radio';
import RadioIcon from './components/RadioIcon/RadioIcon';
import PopupList from '../../components/PopupList/PopupList';
import ButtonGuide from './components/ButtonGuide/ButtonGuide';
import { calculatorFormPropTypes } from './CalculatorFormPropTypes';
import * as styles from './CalculatorForm.module.scss';
const CalculatorForm = /*#__PURE__*/React.forwardRef(({
  form,
  handleSubmit,
  buttonGuide,
  radioIcon,
  errorMsg,
  error,
  popupData
}, ref) => {
  if (!form) {
    return null;
  }
  const renderRadio = elements => elements && /*#__PURE__*/React.createElement("div", {
    className: styles.rootFormItemsWrapper
  }, elements.map(({
    name,
    icon,
    value,
    label
  }, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, radioIcon ? /*#__PURE__*/React.createElement(RadioIcon, {
    name: name,
    icon: icon,
    error: error.radio,
    value: value,
    label: label
  }) : /*#__PURE__*/React.createElement(Radio, {
    name: name,
    icon: icon,
    error: error.radio,
    value: value,
    label: label
  }))));
  const renderSelect = (name, placeholder, options, index, errorMsg, label) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(Select, {
    name: name,
    label: label,
    options: options,
    errorMsg: errorMsg
  }));
  const renderInputs = inputs => inputs && /*#__PURE__*/React.createElement("div", {
    className: styles.rootFormItemsWrapper
  }, inputs.map(({
    name,
    placeholder,
    type,
    label,
    required
  }, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(Input, {
    name: name,
    type: type,
    placeholder: placeholder,
    label: label,
    error: error.input[index],
    errorMsg: errorMsg,
    required: required
  }))));
  const {
    0: visible,
    1: setVisible
  } = useState(false);
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, form && (form === null || form === void 0 ? void 0 : form.fields) && /*#__PURE__*/React.createElement(FormControl, {
    onSubmit: handleSubmit,
    classname: styles.rootForm,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootFieldsWrapper
  }, form.fields.map(({
    type,
    name,
    options,
    placeholder,
    label,
    items
  }, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, (() => {
    switch (type) {
      case 'radio':
        return renderRadio(items);
      case 'text':
        return renderInputs(items);
      case 'select':
        return renderSelect(name, placeholder, options, index, errorMsg, label);
      default:
        return '';
    }
  })()))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootFooter
  }, /*#__PURE__*/React.createElement(Modal, {
    onClose: () => setVisible(false),
    open: visible
  }, /*#__PURE__*/React.createElement(PopupList, popupData)), /*#__PURE__*/React.createElement(ButtonGuide, {
    onClick: () => setVisible(true),
    label: buttonGuide.label
  }), /*#__PURE__*/React.createElement(Button, {
    label: form.submit.label,
    type: "submit",
    variant: "tertiaryDark",
    classname: styles.rootButton
  }))));
});
CalculatorForm.displayName = 'CalculatorForm';
export default CalculatorForm;